import React from 'react';
import {Line} from "react-chartjs-2";
import './Chart.css';
import moment from 'moment';


const StockLineChart = ({stockHistory, change}) => {
    const stockPrice = [];
    const stockTimeStamp = [];
    

    stockHistory?.ticks.forEach((item) => {
            stockPrice.push(item.close);
            stockTimeStamp.push(moment((new Date((item.time*1000)))).format("MMMM'YY")); 
    })
   
    const data = {
        labels: stockTimeStamp,
        datasets: [
            {
                data: stockPrice,
                label: "Stock Price",
                fill : true,
                backgroundColor: `${change > 0 ? "#71d46d48" : "#d1475056"}`,
                borderColor: `${change > 0 ? "#30a02cd2" : "#ff424f"}`,
                pointRadius: 1,
                borderWidth: 2,
            }
        ]
    }

    const options = {
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    }
                }
            ],
        }
    }

    return (
        <> 
        {
            stockPrice.length > 0 ? (
                <Line data={data} options={options}/>
            ) : (
                <></>
            ) 
        }
        </>
    )
}

export default StockLineChart;
